import { Icon } from '@chakra-ui/react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

import { Container, ButtonsScroll, Classifs, Classif } from './styles';

type ClassificacaoData = {
	CODCLA: number;
	CODSCL: number;
	nome: string;
}
interface MenuClassifsParams {
	classifs: ClassificacaoData[];
	selectedClassif: ClassificacaoData;
	setSelectedClassif: (classif: ClassificacaoData) => void;
	handleSearchClassif: (nome: string) => void;
}

const MenuClassifs: React.FC<MenuClassifsParams> = ({
	classifs,
	selectedClassif,
	setSelectedClassif,
	handleSearchClassif,
}) => {
	function handleMenuScroll(sentido: string) {
		const aux = document.getElementById('menu-class');

		if (aux) {
			if (sentido === 'right') {
				aux.scrollLeft += 300;
			} else {
				aux.scrollLeft -= 300;
			}
		}
	};

	function horizontalScroll(e: any) {
		const container = document.getElementById('menu-class');
		// const containerScrollPosition = document.getElementById('menu-class')?.scrollLeft;
		container?.scrollTo({
			top: 0,
			left: container + e.deltaY,
			// behaviour: 'smooth', // if you want smooth scrolling
		});
	};

	function handleSelectScroll(div: string) {
		const target = document.getElementById(`menu-${div}`);

		target?.scrollIntoView({
			behavior: 'smooth',
			block: 'center',
			inline: 'center',
		});
	};

	return (
		<Container>
			<ButtonsScroll onClick={() => handleMenuScroll('left')}>
				<Icon as={FiChevronLeft} fontSize={30} color="gray.300" />
			</ButtonsScroll>

			<Classifs id="menu-class" onWheel={horizontalScroll}>
				{classifs.map((classif) => {
					return (
						<Classif
							key={classif.nome}
							id={`menu-${classif.nome}`}
							selected={classif.nome === selectedClassif.nome ? true : false}
							onClick={() => {
								setSelectedClassif(classif);
								handleSearchClassif(classif.nome);
								handleSelectScroll(classif.nome);
							}}
						>
							<span>{classif.nome}</span>
						</Classif>
					)
				})}
			</Classifs>

			<ButtonsScroll onClick={() => handleMenuScroll('right')}>
				<Icon as={FiChevronRight} fontSize={30} color="gray.300" />
			</ButtonsScroll>
		</Container>
	)
}

export default MenuClassifs;